import { NgModule } from '@angular/core';

import { CertemyCommonModule } from 'common/certemy-common.module';
import { ProfessionalCardComponent } from './professional-card.component';
import { ProfessionalCardServiceModule } from 'features/assignments/shared/prof-card/professional-card.service.module';

@NgModule({
  imports: [CertemyCommonModule, ProfessionalCardServiceModule.forRoot()],
  exports: [ProfessionalCardComponent],
  declarations: [ProfessionalCardComponent],
})
export class ProfessionalsCardModule {}
